import { createSelector } from 'reselect';
import { selectSearchTerm, selectItemUpdates } from '.';
import { isColor } from '../utilities';
import _ from 'lodash';

const selectStones = state => state.stones;

const selectState = state => state;

const selectPageSize = (state, pageSize) => pageSize;

const selectTransientStones = createSelector(
  selectStones,
  stones => stones.transientStones
);

const selectTransientMasterStones = createSelector(
  selectStones,
  stones => stones.transientMasterStones
)

const selectUserUploadedStones = createSelector(
  selectStones,
  stones => stones.userUploadedStones
)

export const selectStoneTags = createSelector(
  selectTransientStones, selectTransientMasterStones,
  (stones, masterStones) => {
    const colors = ["ALL"];
    const materials = ["ALL"];
    stones.forEach(({ tagList }) => {
      tagList.forEach(tag => {
        tag = tag.toLowerCase().trim();
        if (tag.length) {
          const ok = tag.length > 1 && !/\d+x\d+/.test(tag);

          if (ok) {
            if (isColor(tag)) {
              if (colors.indexOf(tag) < 0) {
                colors.push(tag);
              }
            } else if (materials.indexOf(tag) < 0) {
              materials.push(tag);
            }
          }
        }
      });
    });
    masterStones.forEach(({ tagList }) => {
      tagList.forEach(tag => {
        tag = tag.toLowerCase().trim();
        if (tag.length) {
          if (isColor(tag)) {
            if (colors.indexOf(tag) < 0) {
              colors.push(tag);
            }
          } else if (materials.indexOf(tag) < 0) {
            materials.push(tag);
          }
        }
      });
    });
    return {
      colors,
      materials
    };
  }
);

export const selectStonesColorFilter = state => selectStones(state).colorFilter;

export const selectStonesMaterialFilter = state => selectStones(state).materialFilter;

const selectFilteredTransientStones = createSelector(
  [selectTransientMasterStones, selectTransientStones, selectUserUploadedStones, selectSearchTerm, selectStonesColorFilter, selectStonesMaterialFilter],
  (masterStones, transientStones, userUploadedStones, term, colorFilter, materialFilter) => {
    if (transientStones.length > 0 || masterStones.length > 0) {
      const stones = _.unionBy(transientStones, masterStones, userUploadedStones, 'id');
      const filtered = stones.filter(s => {
        var name = s.name;
        if(s.stoneSupplierStones && s.stoneSupplierStones[0] && s.stoneSupplierStones[0].customStoneName && s.stoneSupplierStones[0].customStoneName.length > 0) {
          name = s.stoneSupplierStones[0].customStoneName;
        }
      
        return (!term || (s.name && s.name.toLowerCase().indexOf(term.toLowerCase()) >= 0) || (name && name.toLowerCase().indexOf(term.toLowerCase()) >= 0))
          && (!colorFilter.size || _.intersection(colorFilter.toJS(), s.filterValueIDs).length)
          && (!materialFilter.size || _.intersection(materialFilter.toJS(), s.filterValueIDs).length);
      });
      
      return filtered;
    } else {
      return [];
    }
  }
);

export const selectEnabledTransientStones = createSelector(
  selectFilteredTransientStones,
  filteredTransientStones => filteredTransientStones.filter(s => s.enabled && (s.stoneSupplierStones && s.stoneSupplierStones[0] && s.stoneSupplierStones[0].enabled))
);

export const selectDisabledTransientStones = createSelector(
  selectFilteredTransientStones,
  filteredTransientStones => filteredTransientStones.filter(s => !s.enabled || (s.stoneSupplierStones && s.stoneSupplierStones[0] && !s.stoneSupplierStones[0].enabled))
);

export const selectedEnabledUpdatedTransientStones = createSelector(
  [selectFilteredTransientStones, selectState],
  (filteredTransientStones, state) => filteredTransientStones.filter(s => {
    let item = selectItemUpdates(state, s);
    return item && item.enabled && ( item.stoneSupplierStones && item.stoneSupplierStones[0] && item.stoneSupplierStones[0].enabled );
  })
);

export const selectedDisabledUpdatedTransientStones = createSelector(
  [selectFilteredTransientStones, selectState],
  (filteredTransientStones, state) => filteredTransientStones.filter(s => {
    let item = selectItemUpdates(state, s);
    return (item && !item.enabled) || ( item.stoneSupplierStones && item.stoneSupplierStones[0] && !item.stoneSupplierStones[0].enabled );
  })
);

export const selectSortedEnabledTransientStones = createSelector(
  [selectEnabledTransientStones, selectState],
  (stones, state) => {
    stones.sort((s, s2) => {
      let sss = s.stoneSupplierStones ? s.stoneSupplierStones[0] : null;
      let sss2 = s2.stoneSupplierStones ? s2.stoneSupplierStones[0] : null;
      let s1CustomStoneName = null;
      let s2CustomStoneName = null;
      if(sss) s1CustomStoneName = sss.customStoneName;
      if(sss2) s2CustomStoneName = sss2.customStoneName;
      var n1 = _.trim(s1CustomStoneName || s.name).toString().toLowerCase(),
        n2 = _.trim(s2CustomStoneName || s2.name).toString().toLowerCase();
      if(n1 < n2) return -1;
      if(n1 > n2) return 1;

      //sub-sort by SSS id to prevent stones of the same name from swapping positions
      if(s.stoneSupplierStones[0].id < s2.stoneSupplierStones[0].id) return -1;
      if(s.stoneSupplierStones[0].id > s2.stoneSupplierStones[0].id) return 1;
      
      return 0;
    });
    return stones;
  }
);

var _selectFilteredEnabledTransientStonesPages = createSelector(
  [selectSortedEnabledTransientStones, selectState, selectPageSize],
  (stones, state, pageSize) => {
    return _.chunk(stones, pageSize);
  }
);

export const selectFilteredEnabledTransientStonesPages = (state, pageSize) => _selectFilteredEnabledTransientStonesPages(state, pageSize);